import {
  Image,
  ImageProps,
  Popover,
  PopoverArrow,
  PopoverContent,
  PopoverTrigger,
  Portal,
  useDisclosure
} from "@chakra-ui/react";
import React from "react";

interface Props {
  imageProps?: ImageProps,
  size?: ImageProps["sizes"]
}
export function InfoPopover({ children, imageProps = {}, size = "200px" }: React.PropsWithChildren<Props>) {
  const { isOpen, onToggle, onClose } = useDisclosure();

  return (
    <Popover
      closeOnBlur
      isOpen={isOpen}
      onClose={onClose}
      placement="right"
      variant="info"
    >
      <PopoverTrigger>
        <Image
          cursor="pointer"
          display="inline-block"
          filter="var(--filter-royalblue-100)"
          h={4}
          onClick={onToggle}
          src="/svg/info.svg"
          transform="translateY(2px)"
          w={4}
          {...imageProps}
        />
      </PopoverTrigger>
      <Portal>
        <PopoverContent
          _focusVisible={{ outline: "none" }}
          bg="brand.black.90"
          border="none"
          borderRadius={8}
          color="brand.white.100"
          fontSize="sm"
          p={2}
          w={size}
        >
          <PopoverArrow bg="brand.black.90" />
          <span>{children}</span>
        </PopoverContent>
      </Portal>
    </Popover>
  );
}
